module.exports = __webpack_public_path__ + "img/empty.2af93d0a.svg";